





























































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { getRankList } from '../api';
import { List } from 'vant';

Vue.use(List);

type TabIndexKeyName = 'activeGroupIndex' | 'activeCateIndex';

@Component({
  components: {
    SearchBar,
  },
})
export default class Rank extends Vue {
  tabGroup: string[] = ['专业组', '社会组'];
  tabCate: string[] = ['全部', '数字影像类', '广告招贴类', '文创设计类'];

  activeGroupIndex = 0;
  activeCateIndex = 0;

  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;

  async created() {
    this.onGetRankList();
  }

  onTabChange(index: number, keyName: TabIndexKeyName) {
    this[keyName] = index;
    this.reset();
    this.onGetRankList();
  }

  async onGetRankList() {
    this.loading = true;
    const ret = await getRankList({
      page: this.page,
      group: this.activeGroupIndex + 1,
      work_type: this.activeCateIndex,
    });
    this.loading = false;
    if (!ret.data.length) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...ret.data];
      this.page++;
    }
  }

  reset() {
    this.list = [];
    this.finished = false;
    this.page = 1;
  }
}
